import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { Button, Loader, Switch } from '@gem/ui-kit';

import {
  useMonetizationPopupPresenter,
  IMonetizationPopupPresenterParams,
} from './MonetizationPopup.presenter';
import styles from './MonetizationPopup.styles.m.css';

type IMonetizationPopupProps = IMonetizationPopupPresenterParams;

export const MonetizationPopup: FC<ICommonPopupsProps<IMonetizationPopupProps>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useMonetizationPopupPresenter(props);

    return (
      <Popup
        isOpened
        onClose={presenter.onClose}
        title={t('common_monetization')}
        className={styles.container}
      >
        <AddKeyPressHandler onEsc={presenter.onClose} />
        <div className={styles.content}>
          <label className={styles.item}>
            {t('common_monetization')}
            {presenter.isLoading ? (
              <Loader
                color={'base'}
                className={styles.loader}
              />
            ) : (
              <Switch
                isChecked={presenter.isChecked}
                onChange={presenter.toggle}
              />
            )}
          </label>
          <div className={styles.caption}>{t('common_monetization_tip')}</div>
          <div className={styles.caption}>
            {t('common_monetization_system_link').split('{0}')[0]}
            <button
              className={styles.link}
              onClick={presenter.onClick}
            >
              {t('common_gem4me_ads')}
            </button>
            {t('common_monetization_system_link').split('{0}')[1]}
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            onClick={(): void => presenter.onSave()}
            className={styles.button}
            theme="primary"
          >
            {t('save')}
          </Button>
        </div>
      </Popup>
    );
  }
);
